(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Product_trDialogController', Product_trDialogController);

    Product_trDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product_tr', 'Product'];

    function Product_trDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Product_tr, Product) {
        var vm = this;

        vm.product_tr = entity;
        vm.clear = clear;
        vm.save = save;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.product_tr.id !== null) {
                Product_tr.update(vm.product_tr, onSaveSuccess, onSaveError);
            } else {
                Product_tr.save(vm.product_tr, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:product_trUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
